import React from 'react';
import 'reflect-metadata';
import { createRoot } from 'react-dom/client';
import './index.css';
import { Root } from './Root';
import { iocContainer, TYPES } from '@/engine/ioc';
import type { AppBootstrapper } from '@/engine/app/AppBootstrapper';
import { type Container } from 'inversify';

const surgeriesEntryPoints = import.meta.glob('./surgeries/**/*/main.ts');

(window as unknown as { surgeriesEntryPoints: Record<string, () => Promise<unknown>> }).surgeriesEntryPoints =
  surgeriesEntryPoints;

// eslint-disable-next-line @typescript-eslint/no-floating-promises -- //TODO: [chebotarev] fix eslint no-floating-promises
iocContainer.get<AppBootstrapper>(TYPES.AppBootstrapper).bootstrap();

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);

const appHeight = (): void => {
  const doc = document.documentElement;
  doc.style.setProperty('--app-height', `${window.innerHeight}px`);
};
window.addEventListener('resize', appHeight);
appHeight();

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
(window as any).dangerouslyExposeInternalAPI = (): void => {
  (window as unknown as { iocContainer: Container }).iocContainer = iocContainer;
  console.warn(
    '%cWarning: You have entered the secret developer dimension!',
    'color: orange; font-size: 16px; font-weight: bold;'
  );
  console.warn(
    '%cThe internal APIs have been exposed. Handle with care or risk summoning the bugs! 🐛',
    'color: red; font-size: 14px;'
  );
};
